/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateSessionRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/session_messages.pb'
import {UpdateSessionResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/session_messages.pb'


export const updateSession = (request: UpdateSessionRequest, options?: CashRequestOptions) => post<UpdateSessionRequest, UpdateSessionResponse>("/2.0/cash/update-session", request, {...options, rejectOnError: true })